import { GetThunkAPI } from '@reduxjs/toolkit';
import { setError } from './reducers/errors/errorsSlice';
import { UIErrorTypes } from '@/types/errors';
import { ApiException } from '@/api/exceptions/ApiException';
import { EXCEPTION_CODES } from '@/api/exceptions/codes';

type ThunkApiConfig = object;

export function withDefaultErrorHandling<Payload, Returned>(
  payloadCreator: (payload: Payload, thunkApi: GetThunkAPI<ThunkApiConfig>) => Promise<Returned>,
  skipCodes: EXCEPTION_CODES[] = [EXCEPTION_CODES.NOT_AUTHENTICATED],
) {
  return async (payload: Payload, thunkApi: GetThunkAPI<ThunkApiConfig>) => {
    try {
      return await payloadCreator(payload, thunkApi);
    } catch (error: unknown) {
      if (error instanceof ApiException && skipCodes.includes(error.code)) {
        throw error;
      }

      thunkApi?.dispatch(setError({ type: UIErrorTypes.Snack, message: (error as Error).message }));

      throw error;
    }
  };
}

export function withComponentErrorHandling<Payload, Returned>(
  payloadCreator: (payload: Payload, thunkApi: GetThunkAPI<ThunkApiConfig>) => Promise<Returned>,
  skipCodes: EXCEPTION_CODES[] = [
    EXCEPTION_CODES.SERVER_ERROR,
    EXCEPTION_CODES.ERR_NETWORK,
    EXCEPTION_CODES.SURVEYANSWER_NOT_UNIQUE,
  ],
) {
  return async (payload: Payload, thunkApi: GetThunkAPI<ThunkApiConfig>) => {
    try {
      return await payloadCreator(payload, thunkApi);
    } catch (error: unknown) {
      if (error instanceof ApiException && skipCodes.includes(error.code)) {
        throw error;
      }

      if (error instanceof ApiException) {
        return thunkApi.rejectWithValue(error.fields || error.message);
      }

      throw error;
    }
  };
}
